import type { Bone } from '../lib/skeleton/core';

export type BoneNameTone = 'default' | 'muted' | 'excluded';

type BoneNameClassOptions = {
  italicWhenMuted?: boolean;
};

export function getBoneNameTone(
  bone: Pick<Bone, 'deforming' | 'auxiliary'>,
  isExcluded: boolean,
): BoneNameTone {
  if (isExcluded) return 'excluded';
  if (!bone.deforming || bone.auxiliary) return 'muted';
  return 'default';
}

export function getBoneNameClassName(
  tone: BoneNameTone,
  options?: BoneNameClassOptions,
): string {
  if (tone === 'excluded') return 'text-red';
  if (tone === 'muted') {
    return options?.italicWhenMuted ? 'italic text-gray-400' : 'text-gray-400';
  }
  return 'text-gray-800';
}
